import { useState } from "react";
import { Link } from "react-router-dom";
import { QrCode, ArrowLeft, MailCheck } from "lucide-react";
import { api, fmtErr } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <span className="h-14 w-14 rounded-2xl bg-zinc-900 text-white flex items-center justify-center mb-4">
            <QrCode size={26} />
          </span>
          <h1 className="font-heading text-3xl font-bold tracking-tighter">Asset Passport</h1>
        </div>

        <div className="bg-white rounded-3xl border border-zinc-200/80 card-shadow p-7 sm:p-8" data-testid="forgot-password-page">
          {sent ? (
            <div className="text-center py-4">
              <span className="h-14 w-14 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mx-auto mb-5">
                <MailCheck size={24} />
              </span>
              <h2 className="font-heading text-xl font-semibold tracking-tight">Revisa tu email</h2>
              <p className="text-sm text-zinc-500 mt-3 leading-relaxed" data-testid="forgot-success-message">
                Si existe una cuenta con <strong>{email}</strong>, recibirás un enlace para
                restablecer tu contraseña. El enlace caduca en 1 hora.
              </p>
            </div>
          ) : (
            <>
              <h2 className="font-heading text-xl font-semibold tracking-tight mb-2">¿Olvidaste tu contraseña?</h2>
              <p className="text-sm text-zinc-500 mb-6">
                Introduce tu email y te enviaremos un enlace para restablecerla.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  className="w-full h-12 px-4 rounded-xl border border-zinc-200 bg-white text-base placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-zinc-950 focus:ring-offset-2 transition-shadow"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  data-testid="forgot-email-input"
                />
                {error && (
                  <p className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-xl px-4 py-2.5" data-testid="forgot-error">
                    {error}
                  </p>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="forgot-submit-button"
                  className="w-full h-12 rounded-full bg-zinc-900 text-white font-medium hover:bg-zinc-800 active:scale-[0.98] transition-[background-color,transform] duration-200 disabled:opacity-50"
                >
                  {loading ? "Enviando…" : "Enviar enlace de recuperación"}
                </button>
              </form>
            </>
          )}
        </div>

        <div className="text-center mt-6">
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
            data-testid="back-to-login-link"
          >
            <ArrowLeft size={14} /> Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
